import { useFinanceEntries } from "web_myplann/Finances/Hooks/useFinanceEntries";

export const useFinancialBalance = () => {
	const {
		incomeEntries,
		expenseEntries,
		totalIncome,
		totalExpenses,
		hasIncomeData,
		hasExpenseData,
		isLoading,
		isPending,
	} = useFinanceEntries();

	return {
		isLoading,
		isPending,
		hasNoData: !hasIncomeData && !hasExpenseData,
		hasNoBalance:
			hasIncomeData &&
			hasExpenseData &&
			incomeEntries.length === 0 &&
			expenseEntries.length === 0,
		hasExpenses: expenseEntries.length > 0,
		incomeSum: totalIncome,
		expenseSum: totalExpenses,
		balance: totalIncome - totalExpenses,
	};
};
